import { StoreRequestStateUpdater } from '../types/store-request-state-updater';
import { HttpParams } from '@angular/common/http';

export function getUrlWithParams(url: string, params: { [key: string]: any }): string {
  Object.keys(params).forEach((key) => {
    const value = params[key];
    url = url.replace(`:${key}`, value);
  });
  return url;
}

export function getObjectAsHttpParams(object: any): HttpParams {
  let params = new HttpParams();
  Object.keys(object).forEach((key) => {
    if (object[key] != null) {
      params = params.append(key, object[key]);
    }
  });
  return params;
}

export function getStoreRequestStateUpdater(store: any): StoreRequestStateUpdater {
  return (requestName, requestState) => {
    store.setState({
      ...store.state,
      requests: {
        ...store.state.requests,
        [requestName]: requestState,
      },
    });
  };
}
